package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier


@Composable
fun CoverLetterText(vararg sentences: String) = Column(ForewordStylesheet.CoverText.toModifier()) {
    sentences.forEach { SpanText(it) }
}
